export default __webpack_public_path__ + "static/media/17.3d332f63.jpg";